



































































































































































































































































import { Component, Vue, Inject } from "vue-property-decorator";
import Footer from "../components/Footer.vue";
import TenantSwitch from "../components/tenant-switch.vue";
// import LanguageSwitch from '../components/language-switch.vue'
import iView from "iview";
import AbpBase from "../lib/abpbase";
import Util from "@/lib/util";
import editPassword from "./setting/user/edit-password.vue";
@Component({
  components: { Footer, TenantSwitch , editPassword},
})
export default class Login extends AbpBase {
  loginModel = {
    userNameOrEmailAddress: "",
    password: "",
    rememberMe: false,
  };
  showChangeTenant: boolean = false;
  editpasswordShow: boolean = false;

  // 设置默认租户Default
  async setDefaultTenant() {
    Util.abp.multiTenancy.setTenantIdCookie(1);
  }

  get copyright() {
    return Util.abp.setting.get("Copyright");
  }

  get systemName() {
    return Util.abp.setting.get("SystemName");
  }

  get passwordCheck() {
    return Util.abp.setting.get("passwordCheck");
  }
  get passwordCheckMassage() {
    return Util.abp.setting.get("passwordCheckMassage");
  }

  created() {
    this.setDefaultTenant();
    let self = this;
    document.onkeydown = function (e) {
      let key = (window.event as any).keyCode;
      if (key == 13) {
        self.login();
      }
    };
    const currentLanguage = abp.utils.getCookieValue(
      "Abp.Localization.CultureName"
    );
    if (currentLanguage !== "zh-Hans") {
      abp.utils.setCookieValue(
        "Abp.Localization.CultureName",
        "zh-Hans",
        new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
        abp.appPath
      );
      // setTimeout(location.reload(),2000)
      location.reload();
    }
  }

  async login() {
    (this.$refs.loginform as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Message.loading({
          content: "正在登录",
          duration: 0,
        });
        const u = JSON.parse(JSON.stringify(this.loginModel));
        // u.passwordName =this.loginModel.password;
        var passwordCheck = true;
        try {
          if (this.passwordCheck) {
            var passwordreg = eval(this.passwordCheck);
            if (passwordreg && !passwordreg.test(u.password)) {
              passwordCheck = false;
            }
          }
        } catch (err) {
          console.log(err);
        }
        u.password = window.btoa(u.password);
        var res = await this.$store.dispatch({
          type: "app/login",
          data: u,
        });
        sessionStorage.setItem(
          "rememberMe",
          this.loginModel.rememberMe ? "1" : "0"
        );
        // sessionStorage.setItem('passwordName', u.passwordName);
        // /(?=.*"\d)?=.*"[a-zA-Z])(?=.*[^a-zA-Z0-9])/
        // /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]{8,}$/
        // /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*.])[\da-zA-Z~!@#$%^&*.]{8,}$/
        sessionStorage.setItem("userName", u.userNameOrEmailAddress);
        if (res && passwordCheck) {
          location.reload();
        } else if (res && !passwordCheck) {
          var massage =
            "您的密码不满足" + this.passwordCheckMassage + ",请修改密码！";
          this.$Message.destroy();
          this.$Message.error(massage);
          this.editpasswordShow = true;
        }
      }
    });
  }

  get tenant() {
    return this.$store.state.session.tenant;
  }

  rules = {
    userNameOrEmailAddress: [
      { required: true, message: this.L("UserNameRequired"), trigger: "blur" },
    ],
    password: [
      { required: true, message: this.L("PasswordRequired"), trigger: "blur" },
    ],
  };
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/login.vue